
export const scopeWizTableColumns = (self, other = {}) => {

    let columns = []
    let { type } = other
    if (type.indexOf('Org') !== -1) {
        columns = columns.concat([ {
            title: '管理组织',
            name: 'orgName',
            tableItem: {}
        },
        {
            title: '管理组织编码',
            name: 'orgCode',
            tableItem: {},
        }])
    }
    if (type.indexOf('PositionCategory') != -1) {
        columns = columns.concat([ {
            title: '管理岗位分类',
            name: 'positionCategoryName',
            tableItem: {}
        }])
    } else {
        columns = columns.concat([ {
            title: '管理岗位',
            name: 'positionName',
            tableItem: {}
        }])
    }

    columns = columns.concat([
    {
        title: '状态',
        name: 'state',
        dict: [
            { code: 1, codeName: "有效" },
            { code: 0, codeName: "无效" }
        ],
        tableItem: {},
    },
    {
        title: '创建日期',
        name: 'createTime',
        tableItem: {}
    }])
    return columns
}
export const createColumns= (self, employees, other) => {
    return [
        {
            title: '组织名称',
            name: 'orgName',
            tableItem: {}
        },
        {
            title: '组织编码',
            name: 'orgCode',
            tableItem: {}
        },
        {
            title: '岗位',
            name: 'positionName',
            tableItem: {}
        },
        {
            title: '任职类型',
            dict: [
                { code: 1, codeName: '主职' },
                { code: 2, codeName: '兼职' },
            ],
            name: 'type',
            tableItem: {}
        },
        {
            title: '状态',
            dict: [
                { code: 0, codeName: '离职' },
                { code: 1, codeName: '在职' },
            ],
            name: 'jobState',
            tableItem: {}
        },
        {
            title: '任职来源',
            name: 'channel',
            dict: [
                { code: 0, codeName: "系统" },
                { code: 1, codeName: "企业号" },
                { code: 2, codeName: "DP" },
                { code: 3, codeName: "新能源" },
            ],
            tableItem: {}
        },
        {
            title: '生效时间',
            name: 'hireTime',
            tableItem: {}
        },
        {
            title: '最新修改时间',
            name: 'quitTime',
            tableItem: {}
        }
    ]
}
